import abi from "@abi/NodeController05";
import { useCallback } from "react";
import type { Address } from "viem";
import { useSimulateContract, useWriteContract } from "wagmi";
import useActiveWagmi from "./useActiveWagmi";

const useMigrateContract = (contractAddress: Address) => {
	const { accountAddr } = useActiveWagmi();
	const { data } = useSimulateContract({
		abi: abi,
		address: contractAddress,
		args: [accountAddr],
		functionName: "migrateNodes",
		gas: BigInt("1500000"),
	});

	const {
		isPending: isLoading,
		isSuccess,
		status,
		writeContract,
	} = useWriteContract();
	const write = useCallback(() => {
		if (data?.request) {
			return writeContract(data?.request);
		}
	}, [data]);
	return { data, isLoading, isSuccess, send: write, state: status };
};

export default useMigrateContract;
